import React from "react";

export default function InfoIcon({iconSrc , title , content}) {
  return (
    <>
      <div className="flex flex-col gap-5 justify-center m-auto">
        <img
          src={iconSrc}
          className="w-12"
          alt={`${title} Icon`}
        />
        <h3>{title}</h3>
        <p className="font-light leading-relaxed">
            {content}
        </p>
      </div>
    </>
  );
}
